module.exports = __webpack_public_path__ + "img/logo-oben.7cdd4555.png";